import Vue from 'vue';
import PaymentTypeChoice from './payment/PaymentTypeChoice.vue';
import CCPaymentForm from './payment/method-forms/CCPaymentForm.vue';
import CreditCardSwapForm from './payment/CreditCardSwapForm.vue';
import RecurrencyPaymentForm from './payment/method-forms/RecurrencyPaymentForm.vue';
import CCInvoicePaymentForm from './payment/invoice-forms/CCInvoicePaymentForm.vue';
import PixPaymentForm from './payment/method-forms/PixPaymentForm.vue';
import PixInvoicePaymentForm from './payment/invoice-forms/PixInvoicePaymentForm.vue';
import BoletoPaymentForm from './payment/method-forms/BoletoPaymentForm.vue';
import MonthlyBillPaymentForm from './payment/method-forms/MonthlyBillPaymentForm.vue';
import BoletoGenerationForm from './payment/invoice-forms/BoletoGenerationForm.vue';
import CashPaymentForm from './payment/method-forms/CashPaymentForm.vue';
import PhysicalCCPaymentForm from './payment/method-forms/PhysicalCCPaymentForm.vue';
import DocumentSearchForm from './authentication/DocumentSearchForm.vue';
import AccessChoiceForm from './authentication/AccessChoiceForm.vue';
import AccessCodeVerificationForm from './authentication/AccessCodeVerificationForm.vue';
import PlanosCard from './planos/PlanosCard.vue'
import DataTable from './material/Datatable.vue'
import CheckboxInput from './material/CheckboxInput.vue'
import ExpansionPanel from './material/ExpansionPanel.vue'
import PersonalDataForm from './signup/PersonalDataForm.vue'
import CompanyDataForm from './signup/CompanyDataForm.vue'
import CompanyOwnerDataForm from './signup/CompanyOwnerDataForm.vue'
import AddressDataForm from './signup/AddressDataForm.vue'
import DependentDataForm from './signup/DependentDataForm.vue'
import FreeValueSelectionForm from './signup/FreeValueSelectionForm.vue'
import SocialNumberForm from './signup/SocialNumberForm.vue'
import ChairSelectionForm from './signup/ChairSelectionForm.vue'
import SubtenantChoiceForm from './signup/SubtenantChoiceForm.vue'
import WelcomeKitForm from './signup/WelcomeKitForm.vue'
import OrderBundle from './payment/OrderBundle.vue'
import GroupedInvoicesWarning from './payment/GroupedInvoicesWarning.vue'
import RangeInput from './utils/RangeInput.vue'
import EducationalDataForm from './signup/EducationalDataForm.vue'
import ProductListing from './payment/products/ProductListing.vue'
import SinglePlan from './plans/single-plan.vue';
import GroupPlan from './plans/group-plan.vue';

Vue.component('payment-type-choice', PaymentTypeChoice);
Vue.component('credit-card-payment-form', CCPaymentForm);
Vue.component('credit-card-swap-form', CreditCardSwapForm);
Vue.component('recurrency-payment-form', RecurrencyPaymentForm);
Vue.component('cc-invoice-payment-form', CCInvoicePaymentForm);
Vue.component('boleto-payment-form', BoletoPaymentForm);
Vue.component('monthly-bill-payment-form', MonthlyBillPaymentForm);
Vue.component('boleto-generation-form', BoletoGenerationForm);
Vue.component('cash-payment-form', CashPaymentForm);
Vue.component('pix-payment-form', PixPaymentForm);
Vue.component('pix-invoice-payment-form', PixInvoicePaymentForm);
Vue.component('physical-cc-payment-form', PhysicalCCPaymentForm);
Vue.component('document-search-form', DocumentSearchForm);
Vue.component('access-choice-form', AccessChoiceForm);
Vue.component('access-code-verification-form', AccessCodeVerificationForm);
Vue.component('planos-card', PlanosCard);
Vue.component('data-table', DataTable);
Vue.component('checkbox-input', CheckboxInput);
Vue.component('expansion-panel', ExpansionPanel);
Vue.component('personal-data-form', PersonalDataForm);
Vue.component('company-data-form', CompanyDataForm);
Vue.component('company-owner-data-form', CompanyOwnerDataForm);
Vue.component('address-data-form', AddressDataForm);
Vue.component('dependent-data-form', DependentDataForm);
Vue.component('free-value-selection-form', FreeValueSelectionForm);
Vue.component('social-number-form', SocialNumberForm);
Vue.component('chair-selection-form', ChairSelectionForm);
Vue.component('subtenant-choice-form', SubtenantChoiceForm);
Vue.component('welcome-kit-form', WelcomeKitForm);
Vue.component('order-bundle', OrderBundle);
Vue.component('grouped-invoices-warning', GroupedInvoicesWarning);
Vue.component('range-input', RangeInput);
Vue.component('educational-data-form', EducationalDataForm);
Vue.component('product-listing', ProductListing);
Vue.component('single-plan', SinglePlan);
Vue.component('group-plan', GroupPlan);